import segment from 'src/js/modules/analytics/segment';
import fieldNames from 'src/js/modules/extensions/common/components/link-field/constants/field-names';
import getItemClickAction from 'src/js/modules/extensions/common/helpers/get-item-click-action';

const {
  constants,
  trackers: { trackEvent },
} = segment;

const fieldNameToId = {
  [fieldNames.LINK_TYPE]: null,
  [fieldNames.ANCHOR_REFERENCE]: 'block-input',
  [fieldNames.PAGE_REFERENCE]: 'page-input',
  [fieldNames.EXTERNAL_URL]: 'link-input',
  [fieldNames.PHONE_REFERENCE]: 'phone-input',
  [fieldNames.MAIL_REFERENCE]: 'email-input',
  [fieldNames.EXTERNAL_TARGET_BLANK_SWITCHER]: 'open-in-new-tab',
  [fieldNames.EXTERNAL_NOFOLLOW_SWITCHER]: 'add-no-follow-tag',
  [fieldNames.DOWNLOAD_CUSTOM_PATH_SWITCHER]: 'set-download-url',
};

const trackLinkSettingsFieldChanged = ({ settingId, fieldName, fieldsValues }) => {
  const dialogId = settingId;
  const linkTypeValue = fieldsValues?.[fieldNames.LINK_TYPE];
  const actionType = getItemClickAction(linkTypeValue);

  switch (fieldName) {
    case fieldNames.LINK_TYPE: {
      trackEvent(constants.events.LINK_SETTINGS_INPUT_CLICKED, {
        dialogId,
        inputId: fieldNameToId[fieldName],
        actionType,
      });
      break;
    }

    case fieldNames.ANCHOR_REFERENCE: {
      trackEvent(constants.events.LINK_SETTINGS_INPUT_CLICKED, {
        dialogId,
        inputId: fieldNameToId[fieldName],
        actionType: null,
      });
      break;
    }

    case fieldNames.PAGE_REFERENCE: {
      trackEvent(constants.events.LINK_SETTINGS_INPUT_CLICKED, {
        dialogId,
        inputId: fieldNameToId[fieldName],
        actionType: null,
      });
      break;
    }

    case fieldNames.EXTERNAL_URL: {
      trackEvent(constants.events.LINK_SETTINGS_INPUT_CLICKED, {
        dialogId,
        inputId: fieldNameToId[fieldName],
        actionType: null,
      });
      break;
    }

    case fieldNames.PHONE_REFERENCE: {
      trackEvent(constants.events.LINK_SETTINGS_INPUT_CLICKED, {
        dialogId,
        inputId: fieldNameToId[fieldName],
        actionType: null,
      });
      break;
    }

    case fieldNames.MAIL_REFERENCE: {
      trackEvent(constants.events.LINK_SETTINGS_INPUT_CLICKED, {
        dialogId,
        inputId: fieldNameToId[fieldName],
        actionType: null,
      });
      break;
    }

    case fieldNames.EXTERNAL_TARGET_BLANK_SWITCHER: {
      trackEvent(constants.events.LINK_SETTINGS_OPTION_CLICKED, {
        dialogId,
        optionId: fieldNameToId[fieldName],
        newTabAdjusted: fieldsValues?.[fieldName],
      });
      break;
    }

    case fieldNames.EXTERNAL_NOFOLLOW_SWITCHER: {
      trackEvent(constants.events.LINK_SETTINGS_OPTION_CLICKED, {
        dialogId,
        optionId: fieldNameToId[fieldName],
        newTabAdjusted: null,
      });
      break;
    }

    case fieldNames.DOWNLOAD_FILE: {
      trackEvent(constants.events.LINK_SETTINGS_CHOOSE_FILE_CLICKED, {
        dialogId,
      });
      break;
    }

    case fieldNames.DOWNLOAD_OPTION: {
      trackEvent(constants.events.LINK_SETTINGS_OPTION_CLICKED, {
        dialogId,
        optionId: fieldsValues?.[fieldName],
        newTabAdjusted: null,
      });
      break;
    }

    case fieldNames.DOWNLOAD_CUSTOM_PATH_SWITCHER: {
      trackEvent(constants.events.LINK_SETTINGS_OPTION_CLICKED, {
        dialogId,
        optionId: fieldNameToId[fieldName],
        newTabAdjusted: null,
      });
      break;
    }

    default:
      break;
  }
};

export default trackLinkSettingsFieldChanged;
